export const environment = {
  allowLogin: true,
  apiUrl: 'https://nwm2nqf4nj.execute-api.us-east-1.amazonaws.com',
  enableTrackingPixels: false,
  googleAdsId: 'AW-16886550041',
  googleWebClientId: '1040322666886-063eagml8l0cc50r5c0rtn1jo29duu0i.apps.googleusercontent.com',
  cognitoUserPoolClientId: 'b70pn1f6sdalf6ip9hb5sm4ql',
  cognitoUserPoolId: 'us-east-1_7yGJllNnA',
  cognitoOAuthDomain: 'auth.test.myhomey.io',
  indexingEnabled: false,
  allowReferrals: false,
  cloudWatchRUM: {
    identityPoolId: 'us-east-1:da72b852-3370-4564-ba4d-c3fd5a229144',
    applicationId: '26c2a5d1-0650-4ee9-ad19-4cd7784605c9',
  },
  stripe: {
    publicKey: 'pk_test_51QFIsWKPnlnPWHtwgtXP7EPyYmWG4Fd4yLQPxEkXpN1HSFiS91zeeotC0yMixz6b0zxzUlUmEDphbeDVD8sRtDaW00yg2A0EOA',
  },
  hotjarSiteId: 5305885,
  hotjarVersion: 6,
  appstoreLinks: {
    ios: 'https://apps.apple.com/be/app/homey-nyc/id6748840051',
    android: 'https://play.google.com/store/apps/details?id=io.myhomey.app',
  },
  baseUrl: 'https://test.myhomey.io',
  imagesBaseUrl: 'https://images.test.myhomey.io',
  amplitude: {
    sessionRecordingEnabled: false,
  },
  amplitudeKey: '4648a13cc577cef5ee22696f7c38cc78',
  amplitudeServerUrl: 'https://0ua7gjuyfc.execute-api.us-east-1.amazonaws.com',
  dataRefreshTime: 0,
  debug: true,
  capacitorUpdater: {
    defaultChannel: 'test',
  }
};
